function formatDateToString(date) {
    const pad = (n) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
           `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

function calculateScheduledDate(serviceRequestData, data, orderByMins) {
    console.log(`serviceRequestData`, serviceRequestData);

    let scheduledDate = new Date();

    const offsetMs = parseInt(orderByMins) * 60 * 1000;

    if (serviceRequestData?.orderReadyBy && !data?.rescheduledServiceDate) {
        scheduledDate = new Date(serviceRequestData.orderReadyBy);
    } else if (serviceRequestData?.rescheduledServiceDate && serviceRequestData?.preferredServiceDate) {
        scheduledDate = new Date(new Date(serviceRequestData.rescheduledServiceDate).getTime() - offsetMs);
    } else if (serviceRequestData?.rescheduledServiceDate) {
        scheduledDate = new Date(new Date(serviceRequestData.rescheduledServiceDate).getTime() - offsetMs);
    } else if (serviceRequestData?.preferredServiceDate) {
        scheduledDate = new Date(new Date(serviceRequestData.preferredServiceDate).getTime() - offsetMs);
    }

    const formatted = formatDateToString(scheduledDate);
    console.log(`^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^`, scheduledDate, formatted);

    return formatted;
}


function isScheduled(scheduledDate, statusHistory) {
    console.log(`In the statusHistory:`, statusHistory);

    const acceptedData = statusHistory?.find(val => val.status === "ACCEPTED");
    console.log(`Accepted status data:`, acceptedData);

    if (!acceptedData?.time) {
        return false; 
    }

    const scheduledTime = new Date(scheduledDate.replace(' ', 'T')).getTime();
    const acceptedTime = new Date(acceptedData.time).getTime();
    const now = new Date().getTime();

    if (now > scheduledTime) {
        return false;
    }

    const timeDiff = scheduledTime - acceptedTime; 
    if (timeDiff < 30 * 60 * 1000) {
        return false;
    }

    return true; 
}



module.exports = {
    calculateScheduledDate,
    isScheduled
}